// accordions js start
function faq_taggol() {
  const accordions = document.querySelectorAll("[js-acc-item]");
  const openAccordion = (accordion) => {
    const content = accordion.querySelector("[js-acc-single-content]");
    accordion.classList.add("active");
    const scrollcontent = accordion.getAttribute("js-acc-single-trigger-scroll") || null;
    content.style.maxHeight = 'max-content';
  };
  
  const closeAccordion = (accordion) => {
    const content = accordion.querySelector("[js-acc-single-content]");
    accordion.classList.remove("active");
    if(content){
      content.style.maxHeight = null;
    }
  };
  
  accordions.forEach((accordion) => {
    const intro = accordion.querySelector("[js-acc-single-trigger]");
    const content = accordion.querySelector("[js-acc-single-content]");
    if(intro){
        intro.onclick = (e) => {
          if (content.style.maxHeight) {
            closeAccordion(accordion);
          } else {
            accordions.forEach((accordion) => closeAccordion(accordion));
            openAccordion(e.target.closest('[js-acc-item]'));
          }
        };
    }
  });   
}
// accordions js end

// Menu Hover Start
document.addEventListener("DOMContentLoaded", function () {
  const mainLinks = document.querySelectorAll(".custom_main_link");
  const grandItems = document.querySelectorAll(".custom_mega-penal");

  // ----- 1. Make FIRST childlink active by default -----
  if (mainLinks.length > 0) {
    mainLinks[0].classList.add("active");
    const firstTitle = mainLinks[0].getAttribute("data_title");

    grandItems.forEach((item) => {
      item.style.display = item.getAttribute("data_title") === firstTitle ? "block" : "none";
    });
  }

  // ----- 2. Change active class & show correct grandchild on hover -----
  mainLinks.forEach((link) => {
    link.addEventListener("mouseenter", function () {
      const title = this.getAttribute("data_title");

      // Remove active from all
      mainLinks.forEach((l) => l.classList.remove("active"));

      // Add active to hovered
      this.classList.add("active");

      // Show matching grandchild items
      grandItems.forEach((item) => {
        item.style.display = item.getAttribute("data_title") === title ? "block" : "none";
      });
    });
  });
});

// Menu Hover end

(function() {

  faq_taggol();
  
  const header_operlay = document.querySelector("[data-banner-header-overlay]");
  if(header_operlay){
    document.body.classList.add('header-overlay');   
  } 

  const chatButton = document.querySelector('[data-check-open]') || null;
  if(chatButton){
    chatButton.addEventListener('click', function() {
    const popupElement = document.querySelector('#ShopifyChat') || null;
      if(popupElement){
       const myButton = popupElement.shadowRoot.querySelector('button.chat-toggle') || null; // Select element in shadowRoot inside the wrapper
        if(popupElement){
            myButton.click();
        }
      }
    });
  } 
})();

document.getElementById('HeaderMenu-shop').addEventListener('click', function() {
  document.body.classList.toggle('add_menu');
});

// document.querySelectorAll('.custom_main_link').forEach(function(link) {
//   link.addEventListener('mouseenter', function() {
//     var dataTitle = link.getAttribute('data_title');    
//     document.querySelectorAll('li .custom_main_link[data_title]').forEach(function(el) {
//       el.classList.remove('active');
//     }); 
//     link.classList.add('active');
//     document.querySelectorAll('.custom_mega-penal[data_title]').forEach(function(el) {
//       el.classList.add('hidden');
//     });
//     document.querySelector('.custom_mega-penal[data_title="'+ dataTitle +'"]').classList.remove('hidden');
//   });
// });

const chatButton = document.querySelector('#open-chat-button') || null;
if(chatButton){
  chatButton.addEventListener('click', function() {
  const popupElement = document.querySelector('#ShopifyChat') || null;
    if(popupElement){
     const myButton = popupElement.shadowRoot.querySelector('button.chat-toggle') || null; // Select element in shadowRoot inside the wrapper
      if(popupElement){
          myButton.click();                       
      }
    }
  });
}

document.addEventListener('click', function(event) {
  console.log("event.type", event.target.id === 'ShopifyChat');
  if (event.target.id === 'ShopifyChat') {
    UpdateInboxText(event.target);
  }
});

function UpdateInboxText(element) {
  // console.log("element", element);
  const text_wrapper = element.shadowRoot?.querySelector('.store-info-heading') || null;
  // console.log("text_wrapper", text_wrapper);
  if (text_wrapper) {
    const text_main = text_wrapper.querySelector('h2') || null;
    if (text_main) {
      text_main.innerHTML = window.routes.inxed_popup_text;
    }
  }
}

function ALAcheckCategory() {
  const isALARenderedCategory = setInterval(function () {
    const all_select_var = document.querySelector('inbox-online-store-chat') || null;
    if (!all_select_var) return;

    const all_select_var_test = all_select_var.shadowRoot?.querySelector('.store-info-heading') || null;
    if (all_select_var_test) {
      clearInterval(isALARenderedCategory);
      const text_main = all_select_var_test.querySelector('h2') || null;
      if (text_main) {
        text_main.innerHTML = window.routes.inxed_popup_text;
      }
    }
  }, 500);
}

ALAcheckCategory();

// BLOG ARTICLE DATA NAVIGATE
function smoothScroll(target) {
  var header = document.querySelector('sticky-header');
  var headerHeight = (header ? header.offsetHeight + 10 : 150);
  var targetPosition = target.getBoundingClientRect().top + window.pageYOffset - headerHeight;
  window.scrollTo({
    top: targetPosition,
    behavior: 'smooth'
  });
}

var navigationLinks = document.querySelectorAll('[data-faq__categories-list-item-link-cust] a');
navigationLinks.forEach(function(link) {
  link.addEventListener('click', function(event) {
    event.preventDefault();
    console.log(event);
     const targetId = this.hash ? this.hash.substring(1) : null; 
    const targetElement = document.getElementById(targetId);
    console.log(targetElement);
    if (targetElement) {
      smoothScroll(targetElement);
    }
  });
});

// i click on btn change price 0.81/
// function updatePrice() {
//   var priceElements = document.querySelectorAll('.price-item'); 
//   var price, updatedPrice;
//   const priceText1 = document.querySelector('.product__tax.caption.rte:not(.update-price-text)');
//   const priceText2 = document.querySelector('.update-price-text');

//   priceElements.forEach(function (elem) {
//       let rawPrice = elem.getAttribute('data-price'); 
//       if (!rawPrice) return; 

//       price = parseFloat(rawPrice.replace(/\./g, '').replace(',', '.'));
//       if (isNaN(price)) return;

//       if (document.getElementById('on')?.checked) {
//           updatedPrice = price * 0.81; 
//           priceText1.style.display = 'none';
//           priceText2.style.display = 'block';
//       } else {
//           updatedPrice = price;
//           priceText1.style.display = 'block';
//           priceText2.style.display = 'none';
//       }
//       updatedPrice = updatedPrice.toFixed(2);

//       var formattedPrice = new Intl.NumberFormat('de-DE', {
//           style: 'currency',
//           currency: 'EUR',
//           minimumFractionDigits: 2,
//           maximumFractionDigits: 2
//       }).format(updatedPrice);
//       elem.innerText = formattedPrice; 
//   });
// }

// document.getElementById('on')?.addEventListener('change', updatePrice);
// document.getElementById('off')?.addEventListener('change', updatePrice);

//checkout button hide/show
document.addEventListener('DOMContentLoaded', function () {
  const checkbox = document.querySelector('.shipping-check');
  const checkoutButton = document.querySelector('.cart__checkout-button');
  if (!checkbox || !checkoutButton) return;
  checkoutButton.disabled = true;
  checkbox.addEventListener('change', function () {
    checkoutButton.disabled = !this.checked;
  });
});


// document.addEventListener('DOMContentLoaded', function () {
//   const checkbox = document.querySelector('.data-tab-radio');
//   const checkoutButton = document.querySelector('.cart_btn_with_quantity .button');

//   if (checkoutButton && !checkoutButton.hasAttribute('disabled')) {
//     checkoutButton.disabled = true;

//     checkbox.addEventListener('change', function () {
//       checkoutButton.disabled = !this.checked;
//     });
//   }
// });